import { useState } from "preact/hooks";
import { useSpring, animated } from "react-spring";
import useMeasure from "react-use-measure";
import {
  // single sequential
  schemeBlues,
  schemeGreens,
  schemeGreys,
  schemeOranges,
  // muti sequential
  schemeGnBu,
  schemePuBu,
  schemeYlGnBu,
  schemeYlOrRd,
  // diverging
  schemePRGn,
  schemePiYG,
  schemeRdYlBu,
  schemeSpectral,
  // categorical
  // schemeCategory10,
  // schemePastel1,
  // schemeSet2,
  // schemeTableau10,
} from "d3-scale-chromatic";

const singleSequentialSchemes = [
  { colors: schemeBlues, title: "Blues" },
  { colors: schemeGreens, title: "Greens" },
  { colors: schemeGreys, title: "Greys" },
  { colors: schemeOranges, title: "Oranges" },
];
const multiSequentialSchemes = [
  { colors: schemeYlOrRd, title: "Yellow-Orange-Red" },
  { colors: schemeYlGnBu, title: "Yellow-Green-Blue" },
  { colors: schemeGnBu, title: "Green-Blue" },
  { colors: schemePuBu, title: "Purple-Blue" },
];
const divergingSchemes = [
  // schemeBrBG
  { colors: schemePRGn, title: "Purple-Green" },
  { colors: schemePiYG, title: "Pink-Green" },
  { colors: schemeSpectral, title: "Spectral" },
  { colors: schemeRdYlBu, title: "Red-Yellow-Blue" },
];

/* const categoricalSchemes = [
  schemeCategory10,
  schemePastel1,
  schemeSet2,
  schemeTableau10,
]; */

const schemeCategories = [
  { title: "Sequential (single-hue)", schemes: singleSequentialSchemes },
  { title: "Sequential (multi-hue)", schemes: multiSequentialSchemes },
  { title: "Diverging", schemes: divergingSchemes },
  // { title: "Categorical", schemes: categoricalSchemes },
];

const Swatch = ({
  scheme,
  binsLength,
  rectWidth,
  selectedColorSchemeTitle,
  setColorScheme,
}) => (
  <svg
    onClick={() => setColorScheme(scheme)}
    width={rectWidth * binsLength}
    height={rectWidth}
    class="color-scheme"
    data-selected={scheme.title === selectedColorSchemeTitle}
    title={scheme.title}
  >
    {scheme.colors.map((color, j) => (
      <rect
        x={rectWidth * j}
        width={rectWidth}
        height={rectWidth}
        fill={color}
      />
    ))}
  </svg>
);

const SchemeCategory = ({
  categorySchemes,
  title,
  binsLength,
  selectedColorSchemeTitle,
  setColorScheme,
}) => {
  const rectWidth = 50;

  const categorySchemesDemos = categorySchemes.map(({ colors, title }) => ({
    colors: colors[binsLength],
    title,
  }));

  return (
    <div class="colorscheme-category">
      <h4 class="h4">{title}</h4>
      {categorySchemesDemos.map((scheme) => (
        <Swatch
          scheme={scheme}
          binsLength={binsLength}
          rectWidth={rectWidth}
          selectedColorSchemeTitle={selectedColorSchemeTitle}
          setColorScheme={setColorScheme}
        />
      ))}
    </div>
  );
};

const ColorSchemePicker = ({
  binsLength,
  selectedColorSchemeTitle,
  setColorScheme,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [ref, bounds] = useMeasure();
  const props = useSpring({ opacity: showColorPicker ? 1 : 0 });

  return (
    <div ref={ref} class="mt-4 mb-8 mx-auto w-full sm:w-5/6">
      <button
        class="btn btn-teal mr-4"
        title="Choose another color scheme"
        onClick={() => setShowColorPicker((show) => !show)}
      >
        {showColorPicker ? "Hide color schemes" : "Show color schemes"}
      </button>
      {showColorPicker ? (
        <animated.div
          class="bg-gray-300 px-8 mt-2 py-6 rounded shadow-lg"
          style={props}
        >
          <h2 class="h2">Pick a color scheme</h2>
          <div class="flex justify-between flex-wrap gap-6">
            {schemeCategories.map((category) => (
              <SchemeCategory
                categorySchemes={category.schemes}
                title={category.title}
                binsLength={binsLength}
                selectedColorSchemeTitle={selectedColorSchemeTitle}
                setColorScheme={setColorScheme}
              />
            ))}
          </div>
        </animated.div>
      ) : null}
    </div>
  );
};

export { ColorSchemePicker };
